import Cookies from 'universal-cookie';
import { PREFERRED_LANGUAGE } from './constants';
import { setCookies } from './cookies';

export const getPreferredLanguage = () : string => {
  const cookies = new Cookies();
  const locale = cookies.get(PREFERRED_LANGUAGE);

  if(!locale)
    return 'pt-BR';

  const idiom = locale.slice(0, -2);
  const country = locale.slice(-2).toUpperCase();

  return `${idiom}${country}`;
};

export const updatePreferredLanguageCookie = (preferredLanguage : string) : void => {
  setCookies(PREFERRED_LANGUAGE, preferredLanguage);
};